<template>
  <form
    class="px-1 md:px-4"
    @submit.prevent
  >
    <!-- 氏名 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name"
      >
        氏名
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name"
              v-model="lastName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="煌木"
              type="text"
              required
            >
            <span
              v-if="errors.last_name && errors.last_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="太郎"
              type="text"
              required
            >
            <span
              v-if="errors.first_name && errors.first_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.first_name.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 氏名（カナ） -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name_kana"
      >
        氏名（カナ）
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name_kana"
              v-model="lastNameKana"
              placeholder="キラメキ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name_kana.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstNameKana"
              placeholder="タロウ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.first_name_kana.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- メールアドレス -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_email"
      >
        メールアドレス
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <input
          id="entry_email"
          v-model="email"
          placeholder="taro.kirameki@techacademy.jp"
          type="email"
          required
          class="input w-full border-2 border-co-gray-300"
        >
        <span
          v-if="errors.email && errors.email.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.email.join(', ') }}
        </span>
      </div>
    </div>

    <!-- お問い合わせ種別 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_category_type"
      >
        お問い合わせ種別
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="flex basis-full flex-col items-baseline md:basis-8/12">
        <select
          id="entry_category_type"
          v-model="categoryTypeSelected"
          class="select w-full border-2 border-co-gray-300"
          required
        >
          <option
            v-for="option in categoryTypeOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
        <TeContactFaq :category-type-selected="categoryTypeSelected" />
      </div>
    </div>

    <!-- お問い合わせ内容 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_description"
      >
        お問い合わせ内容
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <textarea
          id="entry_description"
          v-model="description"
          placeholder="具体的に記述してください"
          class="textarea textarea-bordered h-32 w-full border-2 border-co-gray-300"
        />
        <span
          v-if="errors.description && errors.description.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.description.join(', ') }}
        </span>
      </div>
    </div>

    <!-- ボタン -->
    <div class="flex flex-col justify-end pt-4 md:flex-row">
      <div class="basis-full md:ml-auto md:basis-8/12 md:pl-6">
        <!-- 送信するボタン -->
        <button
          class="co-btn-submit-stretch"
          @click="onSubmit"
        >
          送信する
        </button>
        <!-- エラーメッセージ -->
        <span
          v-if="applicationErrors.length !== 0"
          class="te-invalid-feedback inline-block py-2"
        >
          {{ applicationErrors.join(', ') }}
        </span>
        <!-- reCAPTCHA注釈 -->
        <p class="co-display-14 mt-9 text-center">
          このサイトはreCAPTCHAによって保護されており、<br class="hidden lg:block">Googleの
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
          >
            プライバシーポリシー
          </a>と
          <a
            href="https://policies.google.com/terms"
            target="_blank"
          >
            利用規約
          </a>が適用されます。
        </p>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import {
  postContact,
  getCurrentUser,
  getContactCategoryType,
} from '~/utility/fetchAPI'
import validateContactForm from '~/utility/validation/validateContactForm'

// フォームデータ
const lastName = ref('')
const firstName = ref('')
const lastNameKana = ref('')
const firstNameKana = ref('')
const email = ref('')
const description = ref('')
const categoryTypeSelected = ref('')
const categoryTypeOptions = ref([])
const errors = ref<Record<string, string[]>>({})
const applicationErrors = ref<string[]>([])
const currentUser = ref({})

const { $recaptcha, $api } = useNuxtApp()
useQueryInput(description, 'contact_description')

onMounted(async() => {
  try {
    await $recaptcha.init()
  } catch (e) {
    // 何もしない
  }
  getCurrentUser($api).then((response) => {
    currentUser.value = response.data
    if (currentUser.value?.attributes) {
      email.value = currentUser.attributes.email
      lastName.value = currentUser.attributes.last_name
      firstName.value = currentUser.attributes.first_name
      lastNameKana.value = currentUser.attributes.last_name_kana
      firstNameKana.value = currentUser.attributes.first_name_kana
    }
  })
  getContactCategoryType($api, {}).then((response) => {
    categoryTypeOptions.value = response.category_types
    categoryTypeSelected.value = categoryTypeOptions.value[0]?.value

    const categories = {
      about_mentoring: "メンタリングについて",
      about_chat_support: "チャットサポートについて",
      entry_other_courses: "他コースの申し込みについて",
      about_system: "学習システムの使い方について",
      about_curriculum: "カリキュラムについて",
      about_learning: "受講について",
      about_career: "転職・テックアカデミーキャリアについて",
      about_works: "副業・テックアカデミーワークスについて",
      about_campaign: "キャンペーンについて",
      about_system_error: "システムの不具合について",
      request: "機能要望・ご意見",
      about_corporate: "法人向け研修について",
      interview: "取材依頼",
      other_case: "その他",
    }
    const { value } = useQueryInput(categoryTypeSelected, 'contact_category_type')

    const options = categoryTypeOptions.value
    categoryTypeSelected.value = options?.find((option) => option.text == categories[value]).value
  })
})

const onSubmit = async () => {
  const token: string = await $recaptcha.execute('registration')
  const body: any = {
    contact: {
      email: email.value,
      last_name: lastName.value,
      last_name_kana: lastNameKana.value,
      first_name: firstName.value,
      first_name_kana: firstNameKana.value,
      category_type: categoryTypeSelected.value,
      description: description.value,
    },
    recaptcha_token: token,
  }

  validateContactForm(body)
    .then(() => {
      postContact($api, body)
        .then(() => {
          window.location.href = `/contact/completed`
        })
        .catch((errors: any) => {
          applicationErrors.value = errors?.response?.data?.errors
        })
    })
    .catch((_errors: any) => {
      errors.value = _errors
    })
}
</script>

<script lang="ts">
import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'
import TeContactFaq from '~/components/Te/TeContact/TeContactFaq.vue'

const options = {
  components: {
    TeCommonBadgeRequired,
    TeContactFaq,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
